// react
import React, { useContext } from "react";

// mui
import Stack from "@mui/material/Stack";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import { ThemeProvider, createTheme } from "@mui/material/styles";

// context
import { SnackbarContext } from "../../Context/snackbarContext/snackbarContext";

// custom theme
const theme = createTheme({
  palette: {
    warning: {
      main: "#263238",
    },
  },
});

// Alert Function
const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

// CustomizedSnackbar Component
const CustomizedSnackbar = () => {
  const { snackbarData, closeSnackbar } = useContext(SnackbarContext);

  return (
    <ThemeProvider theme={theme}>
      <Stack spacing={2} sx={{ width: "100%" }}>
        <Snackbar
          open={snackbarData.open}
          autoHideDuration={6000}
          onClose={closeSnackbar}
          anchorOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
        >
          <Alert
            onClose={closeSnackbar}
            severity={snackbarData.severity}
            sx={{ width: "100%" }}
          >
            {snackbarData.message}
          </Alert>
        </Snackbar>
      </Stack>
    </ThemeProvider>
  );
};
export default CustomizedSnackbar;
